import React from 'react';

export const PoorRatingIcon = ({ borderClass }: { borderClass?: string }) => {
    return (
        <span className={borderClass}>
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" fill="none">
                <path
                    d="M17.5 33c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z"
                    fill="#FB7E83"
                />
                <path
                    d="M23.9 23.4s-2.4-3.2-6.4-3.2-6.4 3.2-6.4 3.2M23.1 12.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0ZM13.5 12.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z"
                    fill="#FB7E83"
                />
                <path
                    d="M23.9 23.4s-2.4-3.2-6.4-3.2-6.4 3.2-6.4 3.2m11.2-11.2h.016m-9.616 0h.016M33.5 17c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16Zm-10.4-4.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Zm-9.6 0a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};
